module.exports = __webpack_public_path__ + "public/images/book-clubs.1e6164f107b40f84746b80b9a007fa5e.jpg";